import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'e5core-ui-categorization-box',
  templateUrl: './e5core-ui-categorization-box.component.html',
  styleUrls: ['./e5core-ui-categorization-box.component.css']
})
export class E5coreUiCategorizationBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
